import Color from 'color'

// This is the minimum required for "AA" certification
const MIN_CONTRAST = 4.5

/**
 * The "range" is a metric used to determine how
 * vibrant a color is. It checks the delta between
 * the highest and lowest channel values, giving us an indiciation
 * of how dominant one range might be.
 *
 * @example
 * For the RGB value [250, 30, 10] we can see
 * that the red channel dominates, meaning it will be
 * primarily red.
 *
 * From: https://github.com/FormidableLabs/image-palette
 */
const getRGBRange = (color) => {
  let rgb = color.rgb().array().sort()
  let min = rgb[0]
  let max = rgb[2]
  return (max - min) / 25
}

const sortPairsByScore = (pairs) => {
  pairs.sort((a, b) => {
    if (a.score === b.score) {
      return 0
    }
    return a.score > b.score ? -1 : 1
  })
}

// const sortPairsByContrast = (pairs) => {
//   pairs.sort((a, b) => {
//     if (a.contrast === b.contrast) {
//       return 0
//     }
//     return a.contrast > b.contrast ? -1 : 1
//   })
// }

/**
 * Returns the most contrastant colors from a palette,
 * given a base color.
 */
export const contrastColors = (baseColor, palette) => {
  let pairs = []
  let dominantColor = Color(baseColor)

  // Go through all other colors in palette and
  // try to find the most contrastant one
  for (let j=0; j<palette.length; j+=1) {
    let targetColor = Color(palette[j])
    let contrast = dominantColor.contrast(targetColor)
    if (contrast < MIN_CONTRAST) {
      let delta = (MIN_CONTRAST - contrast) / 25
      let lighten = dominantColor
      while (contrast < MIN_CONTRAST) {
        let newColor = lighten ? targetColor.lighten(delta) : targetColor.darken(delta)
          // If the new color is the same as the old one, we're not getting any
          // lighter or darker so we need to stop.
          if (newColor.hex() === targetColor.hex()) {
            break
          }
          let newContrast = dominantColor.contrast(newColor)
          // If the new contrast is lower than the old contrast
          // then we need to start moving the other direction in the spectrum
          if (newContrast < contrast) {
            lighten = !lighten
          }
          targetColor = newColor
          contrast = newContrast
      }
    }
    let range = getRGBRange(targetColor)
    let score = contrast + range
    pairs.push({ color: targetColor, score, contrast })
  }

  let bgColor = dominantColor.hex()
  sortPairsByScore(pairs)
  // sortPairsByContrast(pairs)

  let [fgColor, alternativeColor] = pairs
  if (!alternativeColor) alternativeColor = fgColor
  // let remaining = pairs.slice(2)
  // let alt = alternativeColor
  // let altContrast = alternativeColor.color.contrast(fgColor.color)
  // for (let i=0; i<remaining.length; i+=1) {
  //   let c = remaining[i].color
  //   let contrast = c.contrast(fgColor.color)
  //   if ((contrast > MIN_CONTRAST-2) && (contrast > altContrast)) {
  //     alt = { color: c}
  //   }
  // }

  // if (alternativeColor.color.hex() === alt.color.hex()) {
  //   console.log('alternativeColor = alt', alt.color.hex())
  //   if (bgColor === dominantColor.hex())
  //     alternativeColor = { color: dominantColor.negate()}
  //   else
  //     alternativeColor = { color: dominantColor }
  // } else {
  //   console.log('alternativeColor != alt', alternativeColor.color.hex(), alt.color.hex())
  //   alternativeColor = alt
  // }
  if (alternativeColor.color.hex() === dominantColor.hex()) {
    alternativeColor = { color: dominantColor.negate() }
  }
  let gen = {
    base: bgColor,
    contrasts: [fgColor.color.hex(), alternativeColor.color.hex()]
  }
  // Check if alternative colors are the same as background
  if (gen.contrasts[1] === dominantColor) {
    gen.contrasts[1] = dominantColor.negate()
  }

  return gen
}

/*
 * Add some noise to darken/lighten the palette a bit
 */
export const randomizePalette = (palette) => {
  return palette.map((originalColor) => {
    let color = Color(originalColor)
    let newColor
    if (color.light())
      newColor = color.darken(Math.random() / 20)
    else
      newColor = color.lighten(Math.random() / 20)
    return newColor.hex()
  })
}



// WEBPACK FOOTER //
// ./src/colorProcedures.js